import { Heading } from '../common/Heading';
import { Section } from '../common/Section';

interface ProtocolsHeaderProps {
  bottomContent?: React.ReactNode;
}

export const ProtocolsHeader = ({ bottomContent }: ProtocolsHeaderProps) => {
  return (
    <Section containerClassName="lg:pb-18">
      <Heading as="h1" size="h1" className="text-secondary mb-3 text-left">
        Our Protocols
      </Heading>
      <p className="mb-7.5 max-w-150">
        Each supplement protocol targets the root causes of your health issue —
        using science-backed mechanisms to solve the problem quickly,
        effectively, and without guesswork.
      </p>

      {bottomContent && bottomContent}
    </Section>
  );
};
